<template>
  <div id="app" class="min-h-screen max-h-screen">
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "App",
  data() {
    return {};
  },
  mounted() {
    // Generate data for today
    this.getPayment();
    // // Generate data for today
    // const todayStart = this.moment()
    //   .startOf("day")
    //   .format("x");
    // const todayEnd = this.moment()
    //   .endOf("day")
    //   .format("x");
    // this.makeDummyData({
    //   start: Number(todayStart),
    //   end: Number(todayEnd),
    //   day: "today",
    // });

    // // Generate data for yesterday
    // const yesterStart = this.moment()
    //   .subtract(1, "day")
    //   .startOf("day")
    //   .format("x");
    // const yesterEnd = this.moment()
    //   .subtract(1, "day")
    //   .endOf("day")
    //   .format("x");
    // this.makeDummyData({
    //   start: Number(yesterStart),
    //   end: Number(yesterEnd),
    //   day: "yesterday",
    // });

    setInterval(() => {
      this.getPayment();
    }, 300000);
  },
  sockets: {
    pay_JustNow(data) {
      // update the today, this_week, this_month, this_year, total_amount, total_count for all projects payment
      console.log("pay_JustNow", data);
    },

    pay_NewDay(data) {
      // move today data to yesterday for all projects payment
      // clear today for all projects payment
      console.log("pay_NewDay", data);
    },

    pay_NewWeek(data) {
      // move this_week data to last_week for all projects payment
      // clear this_week for all projects payment
      console.log("pay_NewWeek", data);
    },

    pay_NewMonth(data) {
      // clear this_month for all projects payment
      console.log("pay_NewMonth", data);
    },

    pay_NewYear(data) {
      // clear this_year for all projects payment
      console.log("pay_NewYear", data);
    },
  },

  methods: {
    ...mapActions(["getPayment", "makeDummyData"]),
  },
};
</script>
<style scoped>
html {
  background: #05050f;
}
</style>
